(function(){
    angular
        .module('appback')
        .directive('ngFabricacionexterna', fabricacionExterna);
        fabricacionExterna.$inject = ['PedidosService','StockService','$timeout', 'Upload'];
        function fabricacionExterna(PedidosService,StockService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/pedidos/template?name=fabricacionexterna.twig',
		        scope: {
                    pc:'=',
                },
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {

                        scope.init = function(){
                            function loadStock(){
                                PedidosService.checkStockPendiente(scope.pc.pedidoActivoID,function(stocksPedido){
                                    if(stocksPedido.stock_pendiente_insertar){
                                        $timeout(loadStock, 5000);  
                                    }else{
                                        scope.pc.pedidoActivo.stocks = stocksPedido.stocks;
                                        scope.pc.pedidoActivo.stock_pendiente_insertar = false;
                                        scope.pc.pedidoActivo.fabricacion_externa_completada = stocksPedido.fabricacion_externa_completada;
                                        scope.initStocks();
                                    }
                                });
                            }
                            loadStock();
                        }

                        scope.initStocks = function(){
                            console.log("INIT FABRICACION EXTERNA");
                            angular.forEach(scope.pc.pedidoActivo.stocks, function(linea) {
                                if(linea.material.materialelaborado.length > 0){
                                    linea.material.materialelaborado.forEach(function(elaborado){
                                        elaborado.cantidad_necesaria = elaborado.cantidad * linea.cantidad;
                                        if(!angular.isArray(elaborado.lotes_usados) || elaborado.lotes_usados.length <= 0){
                                            console.log("ENTRO EN LOTE_USADOS", elaborado);
                                            elaborado.lotes_usados = [{lote: "",cantidad: elaborado.cantidad_necesaria}];
                                        }
                                    });
                                }
                            });
                        }
                        scope.init();

                        scope.extraParams = function(elaborado){
                            var extraParams = {"nodetype":"stock_materiales","where":{"material_id": [elaborado.materialgasto_id], "cantidad:>":"0.00","cantidad:!=":""}};
                            if(scope.pc.pedidoActivo.proveedor && scope.pc.pedidoActivo.proveedor.almacen_id){
                                if (angular.isArray(scope.pc.pedidoActivo.proveedor.almacen_id)) {
                                    if (scope.pc.pedidoActivo.proveedor.almacen_id.length > 0) {
                                        extraParams.where.almacen_id = scope.pc.pedidoActivo.proveedor.almacen_id;
                                    }
                                } else {
                                    extraParams.where.almacen_id = [scope.pc.pedidoActivo.proveedor.almacen_id];
                                }
                            }
                            return extraParams;
                        }

                        scope.autocompleteLote = function(lote_ref, material_id, lote){
                            console.log("autocomplete lote", lote_ref, material_id, lote);
                            var almacen_id = null;
                            if(scope.pc.pedidoActivo.proveedor && scope.pc.pedidoActivo.proveedor.almacen_id){
                                almacen_id = scope.pc.pedidoActivo.proveedor.almacen_id;
                            }
                            PedidosService.getSameLote(lote_ref, material_id, almacen_id, function(data){
                                console.log("data return autocomplete lote", data);
                                if(data){
                                    lote.lote = data.id;
                                }
                            });
                        }

                        scope.guardarFabricacionExterna = function(stock){
                            console.log("guardando fabricacion externa", stock);
                            PedidosService.guardarFabricacionExterna(stock, scope.pc.pedidoActivoID, function(data){
                                console.log("data return guardar fabricacion externa", data);
                                if(data.pedido){
                                    scope.pc.pedidoActivo = data.pedido;
                                    scope.init();
                                }
                            });
                        }

			        });
		        }
          }
      }
})();